import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MKButton from "components/MKButton"; // Import MKButton
import Iconify from "components/iconify"; // Import Iconify for icons

export default function CartoonDialog({
  open,
  onClose, // Function to close the dialog
  title = "Cartoon Dialog",
  description = "This is a fun and engaging cartoon-style dialog box.",
  color = "#ff4e50",
  secondaryColor = "#f9d423",
  button1,
  button2,
  sx, // Custom styles
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose} // Close when clicking outside or pressing ESC
      PaperProps={{
        sx: {
          maxWidth: 400,
          textAlign: "center",
          p: 4,
          borderRadius: "20px",
          boxShadow: "8px 8px 0px rgba(0,0,0,0.3)",
          background: `linear-gradient(135deg, ${color}, ${secondaryColor})`,
          border: "4px solid black",
          transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
          ...sx,
        },
      }}
    >
      {/* Title */}
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "#fff",
          textShadow: "2px 2px black",
        }}
      >
        {title}
      </DialogTitle>

      {/* Description */}
      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            color: "#fff",
            mt: 2,
            textShadow: "1px 1px black",
          }}
        >
          {description}
        </Typography>
      </DialogContent>

      {/* Buttons */}
      <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
        {/* Default "OK" Button if button1 is not provided */}
        <MKButton
          variant="contained"
          color={button1?.color || "primary"}
          // href={button1?.href}
          disabled={button1?.disabled}
          startIcon={<Iconify icon={button1?.icon || "mdi:check-circle"} width={24} height={24} />}
          onClick={button1?.onClick ? button1.onClick : onClose} // Defaults to closing the dialog
        >
          {button1?.label || "OK"}
        </MKButton>

        {/* Optional Second Button */}
        {button2 && (
          <MKButton
            variant="contained"
            color={button2.color || "secondary"}
            // href={button2.href}
            disabled={button2.disabled}
            startIcon={<Iconify icon={button2.icon} width={24} height={24} />}
            onClick={button2.onClick}
          >
            {button2.label}
          </MKButton>
        )}
      </DialogActions>
    </Dialog>
  );
}
